<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="funcRoute(cardContent.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(cardContent.title) }} :
            {{ checkLanguage(cardContent.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody class="p-0">
        <CRow :class="checkLangClass() + ' ' + 'm-0'">
          <img :src="imgUrl" class="image-area" />
        </CRow>

        <CRow alignHorizontal="center" alignVertical="center">
          <VocabAudio :cardContent="cardContent" :soundObject="soundObj" />
        </CRow>

        <hr class="ml-5 mr-5 mb-5" />

        <CRow
          v-if="screenSize > 500"
          class="ml-5 mr-5 center-text"
          alignHorizontal="center"
          alignVertical="center"
        >
          <h1 :class="checkLangClass() + ' ' + 'content-text'">
            {{ checkLanguage(cardContent.content.description) }}
          </h1>
        </CRow>
        <CRow
          v-if="screenSize <= 500"
          class="ml-4 mr-4 center-text"
          alignHorizontal="center"
          alignVertical="center"
        >
          <h1 :class="checkLangClass() + ' ' + 'content-text'">
            {{ checkLanguage(cardContent.content.description) }}
          </h1>
        </CRow>

        <CRow class="mb-5" align-vertical="center" align-horizontal="center">
          <CButton
            color="danger"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-2 pb-2"
            @click="funcBackRoute(cardContent.navigate.previous.action)"
            >{{ checkLanguage(cardContent.navigate.previous.title) }}</CButton
          >
          <CButton
            color="success"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 mt-5 pl-4 pr-4 pt-2 pb-2"
            @click="funcRoute(cardContent.navigate.next.action)"
            >{{ checkLanguage(cardContent.navigate.next.title) }}</CButton
          >
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import '../../../../assets/scss/_chineseIcon.scss';
import VocabAudio from '../../../../components/template/Chinese1/VocabAudio.vue';
import {mapGetters} from 'vuex';

export default {
  components: {
    VocabAudio,
  },
  name: 'CardImageLandscape',
  props: {
    cardContent: Object,
    nextTo: Function,
    prevTo: Function,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_SOUND,
      lang: '',
      imgUrl: '',
      vocabData: {
        textPinyin: this.cardContent.vocabPinyin,
        soundPath: this.cardContent.soundPath,
        textChn: this.cardContent.vocabChn,
      },
      test: {},
      soundObj: {},
      screenSize: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    storeLanguage: function (val) {
      this.lang = val;
    },
    cardContent: function () {
      this.soundObj = new Audio(
        this.baseUrl + this.cardContent.content.item[0].data
      );
    },
  },
  mounted() {
    this.setData();
  },

  created() {
    this.lang = this.$store.state.language.language;
    this.soundObj = new Audio(
      this.baseUrl + this.cardContent.content.item[0].data
    );
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    setData() {
      if (this.cardContent) {
        for (var i = 0; i < this.cardContent.content.item.length; i++) {
          var item = this.cardContent.content.item[i];
          if (item.type === 1) {
            this.imgUrl = this.baseUrl + item.data;
          } else if (item.type === 2) {
            this.vocabData.soundPath = this.baseUrl + item.data;
          } else if (item.type === 0 && i === 2) {
            this.vocabData.textChn = item.data;
          } else if (item.type === 0 && i === 3) {
            this.vocabData.textPinyin = item.data;
          }
        }
      } else {
      }
    },
    funcRoute(tempId) {
      this.soundObj.pause();
      let str = tempId.split('-');
      this.$emit('funcRoute', str);
    },
    funcBackRoute(tempId) {
      this.soundObj.pause();

      const path = tempId.split('-');
      // let body = '/' + str[0] + '/' + str[1];
      // this.$store.commit('necessary/setCodePage', str[1]);
      // this.$router.push(body);

      const previousPath = `/v4/${path[0]}/${path[1]}`;

      this.$router.push(previousPath);
    },
  },
};
</script>

<style scoped>
.image-area {
  width: 100%;
  height: 100%;
  background-color: #cccccc;
}
</style>
